'use client';
import React from 'react';

import {DefaultFooter} from '@udemy-v2/react-footer';

export const Footer: React.FC = () => <DefaultFooter />;

export default Footer;
